/*
Author: Vaishnavi
Date: 26/11/2019
Issue Description: Spacing fixes done as per design guidelines
*/
<template>
  <div class="business">
    <toast-message
      :message="errmsg"
      :isToastEnable="toast"
      type="error"
      @close="(val) => toast = val"
    />
    <div class="top-bar">
      <span @click="goBackToMainPage">
        <img src="@/assets/path-2-copy.png" />
      </span>
      <span class="heading_new">{{heading}}</span>
    </div>
    <div class="addflexispace content-new" v-if="!editMode">
      <tl-radio
        name="uploadMethod"
        label="Bulk Upload"
        id="bulkUpload"
        value="bulkUpload"
        v-model="uploadMethod"
      />
      <tl-radio
        name="uploadMethod"
        label="Manual"
        id="manualUpload"
        value="manualUpload"
        v-model="uploadMethod"
      />
    </div>

    <div class="margin-l-l" :class="{'content-new': editMode}">
      <div class="bulkUploadClass" v-if="uploadMethod == 'bulkUpload'">
        <div class="download-btn">
          <div class="download-btn-container">
            <img src="@/assets/download.svg"  class="img" />
            <span class="text" @click="downloadUrl">Download Template</span>
            <loading-animation v-show="showLoader"></loading-animation>
         </div>
        </div>
        <div class="margin-t-15px">
          <upload-file :apiUrl="bulkUploadUrl" @uploadTemplate="onUploadTemplate($event)" />
        </div>
      </div>
      <section v-if="uploadMethod == 'manualUpload'">
        <txt
          autofocus="autofocus"
          label="Name *"
          type="text"
          v-model="formData.name"
          placeholder="Enter Name"
          @onValueChange="save"
          name="Cost Centre"
          data-vv-as="name"
          v-validate="{required: true, regex:nameField, max: nameMaxlength}"
          :classname="errors.has('Cost Centre')"
          :errormsg="errors.first('Cost Centre')"
        />
        <txt
          autofocus="autofocus"
          label="Code"
          type="text"
          class="margin-t-m"
          placeholder="Enter Code"
          v-model="formData.code"
          @onValueChange="save"
          name="CodeCC"
          data-vv-as="code"
          v-validate="{required: false,alpha_num:true, max: nameMaxlength}"
          :classname="errors.has('CodeCC')"
          :errormsg="errors.first('CodeCC')"
        />
        <txt
          class="margin-t-m"
          autofocus="autofocus"
          label="Description"
          type="textarea"
          placeholder="Description"
          v-model="formData.description"
          rows="5"
          @onValueChange="save"
          name="CCDesc"
          data-vv-as="description"
          v-validate="{max: descriptionMaxlength}"
          :classname="errors.has('CCDesc')"
          :errormsg="'Description can not be more than 255 characters'"
        />
        <pop-up-message
          v-if="showSuccessMsg"
          :message="`${formData.name} has been successfully ${editMode ? 'updated' : 'created'}.`"
          btnText="Back To Cost Centre"
          @back="backfrompopup()"
        />
      </section>
      <pop-up-message
        v-if="showSuccessBulkUploadMsg"
        :message="responseMsg"
        btnText="Back To Cost Centre"
        @back="backfrompopup"
      ></pop-up-message>
      <footer>
        <bottom-action-container>
          <btn-grp slot="end">
            <btn text="Cancel" type="secondary" @click="goBackToMainPage" />
            <btn :text="btnText" type="primary" v-on:click="save"></btn>
          </btn-grp>
        </bottom-action-container>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { createDecipheriv } from 'crypto';
import * as config from "@/apis/config.js";
import { api_variables } from "@/apis/variables.js";
import axios from "axios";
import {S3} from "aws-sdk";
export default {
  data() {
    return {
      showLoader: false,
      bulkUploadTemplateUrl:'https://paylief.s3.ap-south-1.amazonaws.com/paylief-bulk-upload-templates/Costcentre.xlsx',
      bulkUploadUrl: api_variables.SERVICE_COST_CENTRE_UPLOAD_TEMPLATE,
      nameMaxlength: null,
      descriptionMaxlength: null,
      responseMsg: "",
      showSuccessBulkUploadMsg: false,
      nameField:null,
      formData: {
        code: "",
        name: "",
        description: ""
      },
      errmsg: "",
      uploadMethod: "manualUpload",
      showSuccessMsg: false,
      toast: false
    };
  },
  computed: {
    orgId() {
      return this.$store.getters["onboard/getOrgId"];
    },
    ...mapGetters({
      record: "onboard/cost_centres/record"
    }),
    le_id() {
      return this.$store.getters["onboard/legal_entities/legal_entity_ID"](
        this.$route.params.entity_index
      );
    },
    btnText() {
      if (this.editMode) {
        return "Update";
      } else {
        return "Add New Cost Centre";
      }
    },
    isEditMode() {
      return this.mode == "edit";
    },
    editMode() {
      return this.$store.getters["onboard/cost_centres/editMode"];
    },
    heading() {
      if (this.editMode) {
        return "Edit Cost Center - " + this.formData.name;
      } else {
        return "Add Cost Centre";
      }
    }
  },
  activated() {
    this.toast = false;
    this.uploadMethod = "manualUpload";
    this.setGlobalValidations();
    this.refresh();
    this.formData = this.record;
  },
  methods: {
    ...mapActions("onboard/cost_centres/", {
      act_create: "create",
      act_update: "update",
      act_fileUpload: "upload",
      act_upload_template: "uploadTemplate", 
    }),
    ...mapActions("payroll/lopsandrlops/", {
    getPreSignedUrl: "createPreSigned"
  }),

  async preSignedUrlFunction() {
  try {
    let res = await this.getPreSignedUrl({
      url: this.bulkUploadTemplateUrl
    });
    if (res.data.payload && res.data.payload.iv && res.data.payload.encryptedPacket) {
      const decryptedLink = await this.decrypt(res.data.payload);
      return decryptedLink;
    } else {
      console.log('Invalid payload structure');
      return null;
    } 
  } catch (e) {
    console.log('Error in preSignedUrlFunction:', e);
    return null; 
  }
},
async downloadUrl() {
      try {
        const downloadLink = await this.preSignedUrlFunction();
        if (downloadLink) {
          let url = JSON.parse(downloadLink);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "cost_center.xls"); //or any other extension
          document.body.appendChild(link);
          link.click();
        } else {
          console.log('Failed to retrieve the download link.');
        }
      } catch (e) {
        console.error('Error during download:', e);
      }
    },
    async decrypt(payload){
    const key = process.env.VUE_APP_PAYSLIP_SECRET;
    const decipher = createDecipheriv('aes-256-cbc', key, Buffer.from(payload.iv, 'hex'));
    const decrypted = Buffer.concat([
        decipher.update(payload.encryptedPacket, 'base64'),
        decipher.final()
    ]);

    return decrypted.toString();
},
    
    /* function to set default configuration for validation */
    setGlobalValidations(){
      try {
        this.nameField = config.Regex.ALPHA_NUM
        this.nameMaxlength = config.MaxLengthSettings.nameLength;
        this.descriptionMaxlength = config.MaxLengthSettings.descriptionLength;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },


    /* function to get response after uploading in bulk */
    async onUploadTemplate(res) {
      try {
          if (res.data && res.data.status) {
            this.responseMsg = res.data.message ? res.data.message : "";
            this.showSuccessBulkUploadMsg = true;
          } else {
            this.toast = true;
            this.errmsg = res.response.data.message;
          }
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },
    
    /* function to go back to main cost centre page */
    goBackToMainPage() {
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/costcenters`
      });
    },

    /* function to hide successpop-up and go back to main cost centre page */
    backfrompopup() {
      this.showSuccessMsg = false;
      this.showSuccessBulkUploadMsg = false;
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/costcenters`
      });
    },

    /* function to go to next page */
    continuee() {
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/grades`
      });
    },
    /* function to refresh the page */
    refresh() {
      try {
        this.formData = {
          code: "",
          name: "",
          description: ""
        };
        this.$validator.reset();
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* server call to create or update cost centres */
    async performAction() {
      try {
        this.$root._data.isSaving = true;
        this.formData.name = this.formData.name.toString().trim();
        let res = null;
        if (this.editMode) {
          res = await this.act_update(this.formData);
        } else {
          res = await this.act_create({
            data: {
              ...this.formData,
              le_id: this.le_id
            }
          });
        }
        if (res.data.status) {
          this.showSuccessMsg = true;
        }
        this.$root._data.isSaving = false;
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* function to validate form */
    save() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.performAction();
        } else {
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .focus();
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center"
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss";
@import "../../../../../../scss/variables";
.download-btn-container {
  display: flex;
  align-items: normal;
  .img {
    height: 18px;
    width: 16px;
    object-fit: contain;
  }
  .text {
    font-size: 14px;
    font-weight: 600;
    color: $color-secondary;
    margin-left: 8px;
    cursor: pointer;
  }
}
.content-new {
  padding: 32px 32px;
  .errorr {
    border: 1px solid #e01717;
  }
  .errorMessage {
    color: #e01717;
  }
}

.business {
  width: 100%;
  height: 100%;
  .top-bar {
    height: 64px;
    box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.12);
    background-color: #ffffff;
    padding: 24px 0 0 32px;
    img {
      cursor: pointer;
      margin-right: 24px;
    }
  }
}

.heading_new {
  height: 19px;
  font-size: 16px;
  font-weight: 600;
  color: #6e6e6e;
}
.addflexispace {
  display: flex;
}
</style>
